// extracted by css-extract-rspack-plugin
export default {"option":"option-3OVKT","selectedIcon":"selectedIcon-2aD45","isHighlighted":"isHighlighted-2264N"};